import type { NiceModalHandler } from '@ebay/nice-modal-react';
import React from 'react';
import { DeleteConfirmModal } from '../../components/generic/DeleteConfirmModal';

interface Props {
  modal: NiceModalHandler<Record<string, unknown>>;
  fileName: string;
  isLoading: boolean;
  onDelete: () => void;
}

export const FileDeleteModal = (props: Props) => {
  const { modal, fileName, onDelete, isLoading } = props;

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this file?'
      confirmation={{ level: 'Level2', confirm: fileName }}
      isLoading={isLoading}
      onDelete={async () => onDelete()}
    />
  );
};
